import { jsxs as h, jsx as c } from "react/jsx-runtime";
import { createContext as k, useState as x, useRef as T, useCallback as p, useMemo as _, useContext as g } from "react";
const v = k(null);
function N() {
  const o = g(v);
  if (!o)
    throw new Error("useToast must be used inside <ToastProvider>");
  return o;
}
function M({ children: o, defaultTtlMs: u = 5e3 }) {
  const [a, d] = x([]), n = T(/* @__PURE__ */ new Map()), e = p((t) => {
    d((r) => r.filter((s) => s.id !== t));
    const i = n.current.get(t);
    i && (clearTimeout(i), n.current.delete(t));
  }, []), m = p(
    (t, i, r) => {
      const s = `t-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
      d((l) => [...l, { id: s, tone: t, message: i }]);
      const f = r?.ttlMs ?? u;
      if (f > 0) {
        const l = setTimeout(() => e(s), f);
        n.current.set(s, l);
      }
      return s;
    },
    [u, e]
  ), b = _(() => ({ toasts: a, push: m, dismiss: e }), [a, m, e]);
  return /* @__PURE__ */ h(v.Provider, { value: b, children: [
    o,
    /* @__PURE__ */ c(
      "div",
      {
        className: "aiskills-toast__viewport",
        role: "region",
        "aria-live": "polite",
        "aria-label": "Notifications",
        children: a.map((t) => /* @__PURE__ */ h("div", { className: `aiskills-toast aiskills-toast--${t.tone}`, role: "status", children: [
          /* @__PURE__ */ c("span", { className: "aiskills-toast__body", children: t.message }),
          /* @__PURE__ */ c(
            "button",
            {
              type: "button",
              className: "aiskills-toast__dismiss",
              onClick: () => e(t.id),
              "aria-label": "Dismiss notification",
              children: "×"
            }
          )
        ] }, t.id))
      }
    )
  ] });
}
export {
  M as ToastProvider,
  N as useToast
};
//# sourceMappingURL=Toast.js.map
